import { combineReducers } from 'redux';
import { all, fork } from 'redux-saga/effects';

import asset, { contextAssetSaga, ContextAssetState } from './asset/ducks';
import customer, { contextCustomerSaga, ContextCustomerState } from './customer/ducks';
import customerAccount, { contextCustomerAccountSaga, ContextCustomerAccountState } from './customerAccount/ducks';
import customerRequest, { contextCustomerRequestSaga, ContextCustomerRequestState } from './customerRequest/ducks';
import { contextSaga } from './ducks';
import external, { contextExternalSaga, ContextExternalState } from './external/ducks';
import internal, { contextInternalSaga, ContextInternalState } from './internal/ducks';
import onlinePayment, { ContextOnlinePaymentState } from './onlinePayment/ducks';
import order, { ContextOrderState } from './order/ducks';
import partnerContract, { ContextPartnerContractState } from './partnerContract/ducks';
import tariffSpace, { contextTariffSpaceSaga, ContextTariffSpaceState } from './tariffSpace/ducks';
import userPreferences, { contextUserPreferencesSaga, ContextUserPreferencesState } from './userPreferences/ducks';

/* STATE */
export interface ContextState {
  internal: ContextInternalState;
  external: ContextExternalState;
  customer: ContextCustomerState;
  customerAccount: ContextCustomerAccountState;
  tariffSpace: ContextTariffSpaceState;
  asset: ContextAssetState;
  userPreferences: ContextUserPreferencesState;
  // ToDo: add consignment & customerRequest to context when possible
  consignment: any;
  order: ContextOrderState;
  customerRequest: ContextCustomerRequestState;
  onlinePaymentData: ContextOnlinePaymentState;
  partnerContract: ContextPartnerContractState;
}

/* ACTION TYPES */

/* ACTIONS */

/* REDUCERS */
export default combineReducers({
  internal,
  external,
  customer,
  customerAccount,
  tariffSpace,
  asset,
  order,
  userPreferences,
  customerRequest,
  onlinePayment,
  partnerContract,
});

/* SELECTORS */

/* EXPORT */
export function* contextMainSaga() {
  yield all([
    fork(contextInternalSaga),
    fork(contextExternalSaga),
    fork(contextCustomerSaga),
    fork(contextCustomerAccountSaga),
    fork(contextTariffSpaceSaga),
    fork(contextAssetSaga),
    fork(contextUserPreferencesSaga),
    fork(contextCustomerRequestSaga),
    fork(contextSaga),
  ]);
}
